var map = {
	"./10.png": "4abd",
	"./13.png": "db11",
	"./14.png": "0d89",
	"./16.png": "c2ae",
	"./7.png": "0f01",
	"./9.png": "6846",
	"./AD1.png": "028b",
	"./AD2.png": "3f57",
	"./AD3.png": "2297",
	"./AD4.png": "9714",
	"./Amenities.png": "1d83",
	"./Bathroom Refresh.png": "31cd",
	"./CHATE.png": "e29d",
	"./Cleaning Service.png": "f82f",
	"./HOUIT-bg.png": "b5a2",
	"./HOUIT-logo.png": "083a",
	"./Late Check Out.png": "369b",
	"./Laundry and Dry Cleaning.png": "ddc1",
	"./Luggage Assistance.png": "cbbb",
	"./Maintenance.png": "6369",
	"./Room Refresh.png": "c871",
	"./Sofa Bed Set Up.png": "3373",
	"./Trash Pick Up.png": "8b0d",
	"./additional.png": "75a0",
	"./arrow-right.png": "e9c1",
	"./avassistance.png": "f4cc",
	"./back.png": "1faf",
	"./back_new.png": "1ff9",
	"./bathroom.png": "c41b",
	"./bedding.png": "b39a",
	"./beverage.png": "69b4",
	"./bingxiang.png": "69c9",
	"./breaktime.png": "440f",
	"./calendar-line.png": "7902",
	"./caozuoshouce.png": "2842",
	"./chuanglian.png": "51ef",
	"./clock-time.png": "e792",
	"./close.png": "04b3",
	"./coffee.png": "0adf",
	"./dengpao.png": "9f87",
	"./dental.png": "1a20",
	"./dianshitouping.png": "8a14",
	"./dilou.png": "6e87",
	"./embassy_suites.png": "3e16",
	"./fanyi-template-2.png": "35db",
	"./fanyi.png": "2189",
	"./floorplan.png": "1ca9",
	"./hotel-info.png": "f054",
	"./hotel-please-clean.png": "2946",
	"./huasa.png": "4d0f",
	"./kongtiao.png": "c579",
	"./matong.png": "12df",
	"./matongxi.png": "6fc2",
	"./message.png": "06b9",
	"./min.png": "0bca",
	"./other.png": "01ac",
	"./othermiscell.png": "9edf",
	"./plus-circle.png": "d5fc",
	"./pool.png": "89a4",
	"./reduce-circle.png": "a483",
	"./requeststaff.png": "59f2",
	"./strongbox.png": "1d79",
	"./taiyang.png": "8e88",
	"./tempcontrol.png": "8679",
	"./towels.png": "39d1",
	"./weibolu.png": "d273",
	"./xishouchi.png": "39ac",
	"./xuehua.png": "25d2",
	"./右箭头.png": "5b78",
	"./购物车.png": "0ee3",
	"./遥控器.png": "15e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";